import { Chip } from "@dash/form";
import { useTheme } from "@emotion/react";
import { appLinkTreesObject } from "@megarax/links";

import { SignalLevel } from "@megaron/docs-contracts";

import { signalAppLabel } from "./signalAppLabel";
import { signalColor, signalLevelLabel } from "./signalLevel";

export const SignalAppChips: React.FC<{ apps: string[] }> = ({ apps }) => {
  const theme = useTheme();

  return (
    <>
      {apps.map((app) => (
        <Chip key={app} variant="secondary" color={appLinkTreesObject[app]?.color ?? theme.colors.primary}>
          {signalAppLabel(app)}
        </Chip>
      ))}
    </>
  );
};

export const SignalLevelChip: React.FC<{ level: SignalLevel }> = ({ level }) => {
  const theme = useTheme();

  return (
    <Chip variant="secondary" color={signalColor(level, theme)}>
      {signalLevelLabel[level]}
    </Chip>
  );
};
